import script from "./SkeletonLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./SkeletonLoader.vue?vue&type=script&setup=true&lang=js"

import "./SkeletonLoader.vue?vue&type=style&index=0&id=97a1f526&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97a1f526"]])

export default __exports__